import React from 'react';
import { InterPoint } from '@saviynt/common';
import {
  Avatar,
  Box,
  ButtonIcon,
  Icon,
  Typography,
} from '@saviynt/design-system';
import { format, isValid } from 'date-fns';

import { CF_NEU_BLD, CF_NEU_STL } from '../../../../../shared/constants';
import { useInvertedLocalize } from '../../../../../shared/hooks';
import { type ViolationMitigatingControls } from '../../../data-layer/detailsTypes';

/**
 * MitigateTralingContent
 */
function MitigateTralingContent() {
  return (
    <Box className='Sod-ViolationsTabDetailsMitigating-trailing'>
      <ButtonIcon
        isDisabled
        size='large'
        kind='outlinedSecondary'
        icon={<Icon kind='ExtendEndDate' />}
        onClick={() => {}}
      />
      <ButtonIcon
        isDisabled
        size='large'
        kind='outlinedSecondary'
        icon={<Icon kind='Delete' />}
        onClick={() => {}}
      />
    </Box>
  );
}

/**
 * MitigateCenterContent
 */
function MitigateCenterContent({
  row,
  globalDateFormat,
}: {
  row: ViolationMitigatingControls;
  globalDateFormat: string;
}) {
  const l = useInvertedLocalize();
  const { approverName, startDate, endDate, name } = row;

  const getInitials = approverName
    ? approverName
        .split(' ')
        .filter(Boolean)
        .map((part, i, arr) => {
          const cleanPart =
            i === arr.length - 1
              ? part.replace(/[(){}]/g, '') // remove brackets from final word
              : part;

          return i === 0 || i === arr.length - 1 ? cleanPart[0] : '';
        })
        .join('')
        .toUpperCase()
    : '';

  return (
    <Box className='Sod-ViolationsTabDetailsMitigating-centerContent'>
      {/* Upper */}
      <Box className='Sod-ViolationsTabDetailsMitigating-rowUpper'>
        <Typography kind='h3' lineLimit={1}>
          {name}
        </Typography>
      </Box>
      {/* Lower */}
      <Box className='Sod-ViolationsTabDetailsMitigating-rowLower'>
        {/* Start */}
        <Box className='Sod-ViolationsTabDetailsMitigating-inlineRowText'>
          <Typography kind='body2' color={CF_NEU_STL} isNoWrap>
            {l('Start')}:
          </Typography>
          <Typography kind='body2' color={CF_NEU_BLD} isNoWrap>
            {isValid(new Date(startDate))
              ? format(new Date(startDate), globalDateFormat)
              : '-'}
          </Typography>
        </Box>
        {/* End */}
        <InterPoint color='neutralBold' font='body2' />
        <Box className='Sod-ViolationsTabDetailsMitigating-inlineRowText'>
          <Typography kind='body2' color={CF_NEU_STL} isNoWrap>
            {l('End')}:
          </Typography>
          <Typography kind='body2' color={CF_NEU_BLD} isNoWrap>
            {isValid(new Date(endDate))
              ? format(new Date(endDate), globalDateFormat)
              : '-'}
          </Typography>
        </Box>
        {/* Mitigated By */}
        {approverName && (
          <>
            <InterPoint color='neutralBold' font='body2' />
            <Box className='Sod-ViolationsTabDetailsMitigating-inlineRowText'>
              <Typography kind='body2' color={CF_NEU_STL} isNoWrap>
                {l('Added by')}:
              </Typography>
              <Avatar size='xxSmall'>{getInitials}</Avatar>
              <Typography kind='body2' color={CF_NEU_BLD} isNoWrap>
                {approverName}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}

export { MitigateCenterContent, MitigateTralingContent };
